import { createAction } from '../../base/fsa';

export const setUserAction = createAction(resolve => (username: string, password: string, security_control: string, security_code: string) => resolve({ username, password, security_control, security_code }));

export const clearUserAction = createAction();
